export function getCSSUnitValue(value) {
  return typeof value === 'string' ? value : "".concat(value, "px");
}